import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import {OnOff} from 'HelperFunctions/Lists';

type Props = {
    label: string;
    disabled: boolean;
    label2: string;
    e2eId?: string;
};

class OnOffField extends React.PureComponent<WrappedFieldProps & Props> {
    public render() {
        const {input, meta, label, disabled, label2} = this.props;
        let formClasses: string = 'form_field OnOffField';

        formClasses += meta.error && meta.touched ? ' form_field--has_error' : '';
        formClasses += disabled ? ' form_field--disabled' : '';

        const value = input.value;
        return (
            <div className="form-field">
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                <div className="flex">
                    <OnOff
                        isOn={value}
                        onClick={(item: boolean) => {
                            input.onChange(!item);
                        }}
                        e2eId={(this.props.e2eId) ? this.props.e2eId : null}
                    />
                    {label2 != undefined && <span className="ml-10">{label2}</span>}

                    {(meta.touched &&
                        (meta.error && (
                            <div className="form-field__error"
                                 date-e2eid={(this.props.e2eId) ? this.props.e2eId + "_error" : null}>
                                {meta.error}
                            </div>
                        ))) ||
                    (meta.warning && <span>{meta.warning}</span>)}
                </div>
            </div>
        );
    }
}

export default OnOffField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/OnOffField.tsx